import { useCallback, useMemo } from "react"
import { useGetCollections } from "~/hooks/useCollections"
import { trackEvent } from "~/hooks/useTrackingService"
import { useFilterScope } from "~/providers/FilterScopeProvider"
import { api } from "~/utils/api"
import { filterNotUndefinedOrNull } from "~/utils/tsUtils"

export const useFilters = () => {
  const { filters, setFilters, clearAll: clearAllInScope } = useFilterScope()
  const { data: collections } = useGetCollections()
  const { data: vendors } = api.vendor.getAll.useQuery()

  const clearAll = useCallback(async () => {
    trackEvent("Filters Cleared")
    await clearAllInScope()
  }, [clearAllInScope])

  const filteredCollections = useMemo(() => {
    if (!filters?.length || !collections) return []
    const filteredCollections = filters
      ?.filter((f) => f.field === "collections" && f.operator === "oneOf")
      ?.map((f) => f.values)
      .flat()
      .map((id) => collections?.find((c) => c.name === id))
    return filterNotUndefinedOrNull(filteredCollections)
  }, [filters, collections])

  const filteredVendorIds = useMemo(() => {
    if (!filters?.length || !vendors) return []
    const vendorNames = filters
      ?.filter((f) => f.field === "vendors" && f.operator === "oneOf")
      ?.flatMap((f) => f.values)
    if (!vendorNames?.length) return []
    return vendors
      .filter((v) => vendorNames.some((n) => n.toLowerCase() === v.name.toLowerCase()))
      .map((v) => v.vendorId)
  }, [filters, vendors])

  return {
    filters: filters ?? [],
    setFilters,
    clearAll,
    filteredCollections,
    filteredVendorIds,
  }
}
